import styled from 'styled-components/macro';

export const Container = styled.div`
    padding-right: var(--space-md);
    padding-left: var(--space-md);
    padding-bottom: var(--space-md);
`;
